import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-featured-topics',
		path: '/admin/featured_topics',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_featuredTopics" */ './index'), {
			exportName: 'FeaturedTopics',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
